interface Profile {
  name?: string | null
  core_memory?: Record<string, any> | string | null // Allow string for defensive parsing
}

/**
 * Centralized function to check if a user needs onboarding
 * A user needs onboarding if they don't have a profile name or core memory
 */
export const needsOnboarding = (profile?: Profile | null): boolean => {
  if (!profile || !profile.name) return true

  // Handle both string (bug) and object (correct) core_memory
  const coreMemory = profile.core_memory
  if (!coreMemory) return true

  // If it's a string, parse it (defensive fix for Supabase serialization bug)
  if (typeof coreMemory === 'string') {
    try {
      const parsed = JSON.parse(coreMemory)
      return Object.keys(parsed || {}).length === 0
    } catch (error) {
      console.error('[needsOnboarding] Failed to parse core_memory string:', {
        error: error instanceof Error ? error.message : String(error),
        coreMemoryLength: coreMemory?.length,
        coreMemoryPreview: coreMemory?.substring(0, 100),
      })
      return false // Invalid JSON = does NOT need onboarding (preserves original behavior)
    }
  }

  // Normal case: it's already an object
  return Object.keys(coreMemory || {}).length === 0
}